'use strict';

import React, { Component } from 'react';
import Layout from 'Layouts/Front';
import Button from '@material-ui/core/Button';
import Breadcrumb from 'Components/Front/Breadcrumb';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import variant from 'Functions/variant';
import bemit from 'Functions/bemit';
import { URL, action } from 'Shared/Routes';
import Link from 'Pure/Link';
import Image from 'Pure/Image';
const {
  app,
  moment,
  qwest
} = window;
export default class AllNewsPage extends Component {
  state = {
    loading: true
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchNews({});
    component.fetchPage();
  }
  fetchNews = ({
    scope
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('getAllNews'), {
      limit: 0,
      skip: 0,
      scope: 'all',
      front: true,
      order: 'desc',
      order_by: 'date'
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        news: response.data || []
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  fetchPage = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post(action('FetchPageInfos'), {
      url: document.location.pathname,
      type: 'page'
    }).then(function (xhr, response) {
      component.setState({
        ...response,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const breadcrumb = [{
      name: 'home',
      url: URL('HomePage'),
      label: 'Accueil'
    }, {
      name: 'current-page',
      url: URL('AllNewsPage'),
      label: 'Actualités'
    }];
    const news = (state.news || []).map(function (news) {
      const city = news?._etablishment?.address?.city;
      let output = /*#__PURE__*/React.createElement("div", {
        className: bemit('c-card'),
        key: news.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-card__img-container"
      }, /*#__PURE__*/React.createElement(Image, {
        className: "c-card__img",
        src: variant({
          img: news.images[0],
          size: 900,
          ratio: '16:9'
        }),
        alt: news.title
      })), /*#__PURE__*/React.createElement("div", {
        className: "c-card__content"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "c-card__title"
      }, news.title), /*#__PURE__*/React.createElement("div", {
        className: "c-news__scope c-news__scope--dark"
      }, city, city ? ' - ' : undefined, moment(news.date).format('DD/MM/YYYY')), /*#__PURE__*/React.createElement("div", {
        className: "c-card__link-container"
      }, /*#__PURE__*/React.createElement(Button, {
        className: bemit('c-flat-btn', ['front', 'blue', 'spaces-types-block']),
        href: '/actualites/' + news.url,
        component: Link
      }, "En savoir plus"))));
      return output;
    });
    let output = /*#__PURE__*/React.createElement(Layout, props, /*#__PURE__*/React.createElement("div", {
      className: bemit('c-front-page-intro', ['static-page'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__bg"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__content"
    }, /*#__PURE__*/React.createElement("header", {
      className: "c-front-page-intro__left"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "c-front-page-intro__title"
    }, "Les derni\xE8res actualit\xE9s myWO")))), /*#__PURE__*/React.createElement("div", {
      className: "front-internal-page"
    }, /*#__PURE__*/React.createElement(Breadcrumb, {
      bemit: ['no-padding'],
      links: breadcrumb
    }), /*#__PURE__*/React.createElement("section", {
      className: "o-news-block " + bemit('o-section')
    }, !state.loading && news.length === 0 ? getFormStatus({
      statement: 'Rien pour le moment !'
    }, ['v2']) : undefined, /*#__PURE__*/React.createElement("div", {
      className: "o-section__grid o-news-block__list"
    }, news))));
    return output;
  }
}
